import React from 'react';

import { ListContextContainer } from './list-context';

import Viewport from 'src/components/viewport';
import ProductHeaderDesktop from './components/header-desktop';
import { ProductHeaderMobile } from './components/header-mobile';

import { ProductHeaderProps } from './types';

export const ProductHeader = React.memo((props: ProductHeaderProps) => {
  return (
    <ListContextContainer>
      <>
        <Viewport desktop tablet>
          <ProductHeaderDesktop {...props} />
        </Viewport>
        <Viewport mobile>
          <ProductHeaderMobile {...props} />
        </Viewport>
      </>
    </ListContextContainer>
  );
});
